import { render, staticRenderFns } from "./Privacidad.vue?vue&type=template&id=b86d0d92&scoped=true&lang=pug&"
import script from "./Privacidad.vue?vue&type=script&lang=js&"
export * from "./Privacidad.vue?vue&type=script&lang=js&"
import style0 from "./Privacidad.vue?vue&type=style&index=0&id=b86d0d92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86d0d92",
  null
  
)

export default component.exports